import { CUSTOMERAUTH_DETAIL_REQUEST, CUSTOMERAUTH_DETAIL_REQUEST_ERROR } from "./constantTypes";


const initialAuthState = {
    isloggedIn: false,
    email:``,
    error: ''
}
export const customerAuthReducer = (state = initialAuthState, action) => {
   
    switch (action.type) {
        case CUSTOMERAUTH_DETAIL_REQUEST:
            return {
                ...state,
                auth: action.payload,
                loading: false,
                error: ''
            }
        case CUSTOMERAUTH_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                auth: {},
                loading: false,
                error: action.payload
            }
        default:
           return state;
    }
}